<template>
    <form>
        <div class="container nopadding">
            <div class="wrapper">
                <div class="header"><h1>{{ $t('carrello_ordine_label') }}</h1></div>

                <div class="content-carrello">
                    <!-- ORDINE DAL TAVOLO -->
                    <inc-user-data
                        v-if="!this.user_authenticated"
                        :privacy-checkboxes="this.privacy_checkboxes"
                        @onUserDataChange="this.onUserDataChange"
                    />

                    <!-- INDIRIZZO CONSEGNA -->
                    <inc-delivery-addresses v-if="['DELIVERY', 'DIL'].includes(this.order.type)"
                                            v-model="delivery_point"
                                            @onChangeAddress="onChangeAddress"
                                            @onNewAddress="retrieveDeliveryAddresses"
                                            @onClickNoAddress="selected_address = null"
                                            @onClickYesAddress="onClickYesAddress"
                                            :zone="this.zone"
                                            :addresses="this.addresses"
                                            :selected-address="this.selected_address"
                                            :delivery-cities="this.delivery_cities"
                                            :configuration-service="this.configuration_service"
                                            :countries="this.countries"
                                            :order-address="this.order_address"
                    />
                    <!-- PAGAMENTO -->
                    <inc-payment-mode :items="this.payment_modes"
                                      :value="this.payment_mode ? this.payment_mode.id : null"
                                      @onItemPress="this.onPaymenModePress"
                                      @onNewCardPress="this.onNewCardPress"
                                      @onDeletePress="this.onCardDeletePress"
                    />

                    <!-- FATTURA -->
                    <div class="blocchetto-titolo">
                        <span>
                            <img src="/img/be/ico-fattura.png">{{ $t('carrello_richiedi_fattura') }}
                        </span>
                        <span class="float-right">
                            <mcw-checkbox v-model="invoice_enabled" :disabled="!!this.locale.f_fat_obbligatoria"/>
                        </span>
                    </div>
                    <div class="blocchetto-selezioni" v-if="this.invoice_enabled">
                        <a href="#" class="a2 float-right" @click.prevent="show_modal_billing_address = true">
                            <i class="fas fa-pencil-alt"></i>
                        </a>
                        <div v-if="this.billing_address">
                            {{ $t('carrello_predefinito') }}:
                        </div>
                        <div v-else>
                            {{ $t('carrello.indicazione_fattura') }}
                        </div>
                        <div v-if="this.billing_address">
                            <span v-if="this.billing_address.fatturazione_tipo === 'AZIENDA'">
                                {{ this.billing_address.ragione_sociale }}
                                <br/>
                                {{ $t('piva') }}: {{ this.billing_address.p_iva }} -
                            </span>
                            <span v-if="this.billing_address.cod_fisc">
                                {{ $t('cod_fisc') }}: {{ this.billing_address.cod_fisc }}
                            </span>
                            <br/>
                            {{ this.billing_address.indirizzo }}, {{ this.billing_address.numero }}
                            <span v-if="this.billing_address.campanello">
                                - {{ this.billing_address.campanello }}
                            </span>
                            <span v-if="this.billing_address.cap_citta">
                                - {{ this.billing_address.cap_citta }}
                            </span>
                            {{ this.billing_address.localita_citta }}
                            <span v-if="this.billing_address.provincia">
                                ({{ this.billing_address.provincia }})
                            </span>
                            <span v-if="this.billing_address.nazione">
                                <br/>{{ this.billing_address.nazione }}
                            </span>
                            <span v-if="this.billing_address.sdi && this.billing_address.pec">
                                <br/>
                                <span v-if="this.billing_address.sdi">
                                    SDI: {{ this.billing_address.sdi }} - PEC: {{ this.billing_address.pec }}
                                </span>
                            </span>
                            <span v-else-if="this.billing_address.sdi">
                                SDI: {{ this.billing_address.sdi }}
                            </span>
                            <span v-else-if="this.billing_address.pec">
                                PEC: {{ this.billing_address.pec }}
                            </span>
                        </div>
                    </div>

                    <!-- RIEPILOGO CARRELLO -->
                    <div class="blocchetto-titolo">
                        <span><img src="/img/be/ico-riepilogo.png">{{ $t('carrello_riepilogo') }}</span>
                    </div>

                    <!-- prodotto -->
                    <inc-cart-products :coupon="this.coupon"/>

                    <!-- costo fisso -->
                    <div class="consegna" v-if="this.total_fixed_cost !== false">
                        <div class="row">
                            <div class="col-sm-9 col-md-10">
                                <img src="/img/be/ico-costo-fisso.png" class="float-left">
                                <span>
                                    {{ this.configuration_service.costo_fisso_nome }}
                                    <span v-if="this.configuration_service.costo_fisso_tipo === 'PERCENTUALE'">
                                        ({{ this.configuration_service.costo_fisso }} %)
                                    </span>
                                    <span v-if="this.order.n_persone">
                                        &nbsp;(x{{ this.order.n_persone }})
                                    </span>
                                </span>
                                <div v-if="this.configuration_service.costo_fisso_descrizione">
                                    {{ this.configuration_service.costo_fisso_descrizione }}
                                </div>
                            </div>
                            <div class="col-sm-3 col-md-2">
                                <div class="prezzo">
                                    {{ this.total_fixed_cost.toFixedGood(2) }} {{ locale_currency }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- spese consegna -->
                    <div v-if="this.add_delivery_charge" class="consegna">
                        <div class="row">
                            <div class="col-xs-9 col-sm-10">
                                <img src="/img/be/ico-consegna.png" class="float-left">
                                Consegna
                            </div>
                            <div class="col-xs-3 col-sm-2">
                                <div class="prezzo">
                                    <span v-if="this.delivery_charge">
                                        {{ this.delivery_charge.toFixedGood(2) }} {{ locale_currency }}
                                    </span>
                                    <span v-else>
                                        {{ $t('gratis') }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="consegna" v-if="this.user_authenticated && this.fidelity_points">
                        <div class="row">
                            <div class="col-sm-6 offset-sm-3 text-center">
                                {{ $t("precalculated_fidelity_points_1") }} {{ this.fidelity_points }}
                                {{ $t("precalculated_fidelity_points_2") }}
                            </div>
                        </div>
                    </div>
                    <hr v-if="this.fidelity_points">

                    <!-- CODICE SCONTO -->
                    <div v-if="this.restaurant_settings.f_codici_sconto">
                        <div class="blocchetto-titolo">
                            <span><img src="/img/be/ico-gift.png">{{ $t("sconto") }}</span>
                        </div>
                        <div class="form-inline text-center justify-content-center" style="padding:10px;">
                            <div class="form-group">
                                <label style="margin-right:5px;"><b>{{ $t('carrello_ins_sconto') }}*</b></label>
                                <input type="text" class="form-control text-uppercase" v-model="coupon_temp"
                                       :placeholder="$t('ordine_sconto')" style="width:250px; margin:0 auto;">
                            </div>
                            <button class="btn btn-primary btn-sm" style="margin-left:5px;" type="button"
                                    @click="applyCoupon()" :disabled="!this.coupon_temp.length || this.coupon_check">
                                <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"
                                      v-if="this.coupon_check"></span>
                                {{ $t('carrello_appl_sconto') }}
                            </button>
                            <div>
                                <p class="f1 gray mt-1"><i>* {{ $t('carrello_appl_sconto_dett') }}</i></p>
                                <p class="f1 red" v-if="this.coupon && this.items_with_nodiscount_present"><i>* <img
                                    src="/img/be/ico-nodiscount.png" width="20"/> {{ $t('sconti_non_applicabili') }}</i>
                                </p>
                            </div>
                            <p class="d-none"
                               style="margin-top:10px; font-size:16px; text-align:center; width:100%; padding:10px; background-color: #f5f5f5;"></p>
                        </div>
                        <div class="consegna" v-if="this.coupon">
                            <div class="row">
                                <div class="col-sm-9 col-md-8 col-lg-6">
                                    <span class="text-uppercase" style="padding-left: 55px;">
                                        {{ this.coupon.nome }}
                                        <span v-if="this.coupon.valore">
                                            <span v-if="this.coupon.tipo === 'PERCENTUALE'">
                                                ({{ this.coupon.valore }}%)
                                            </span>
                                            <span v-else>
                                                ({{ this.coupon.valore }} {{ locale_currency }})
                                            </span>
                                        </span>
                                    </span>
                                    <span style="cursor: pointer;" class="red" @click="coupon = null">
                                        ({{ $t("rimuovi_sconto") }}<i class="fa fa-times ml-2"></i>)
                                    </span>
                                </div>
                                <div class="col-sm-3 col-md-4 col-lg-6">
                                    <div class="prezzo">
                                        <span v-if="this.coupon.f_spedizione_gratis">
                                            {{ $t('coupon_spedizione_gratuita') }}
                                        </span>
                                        <span v-else>
                                            {{ (-1 * this.total_coupon).toFixedGood(2) }} {{ locale_currency }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr>
                    </div>

                    <!-- fidelity -->
                    <div v-if="this.fidelity_rewards.length">
                        <div class="blocchetto-titolo d-md-flex justify-content-md-between">
                            <span class="text-uppercase">
                                <i class="fa fa-id-card mx-3" style="color: #ababab; font-size:22px;"></i>
                                {{ $t("layout_fidelity_card") }}
                            </span>

                            <button class="btn btn-default mt-2 mt-md-0" type="button"
                                    @click="show_modal_rewards = true">
                                {{ $t("premi_accumulati") }}
                            </button>
                        </div>

                        <div class="form-inline text-center justify-content-center"
                             style="padding:10px; border-bottom: solid 1px #ebebeb;" v-if="this.can_add_rewards">
                            <div class="form-group">
                                <label style="margin-right:5px;">
                                    <b class="text-uppercase">{{ $t("usa_premio_ordine") }}</b>
                                </label>
                                <select class="form-control" style="width:250px; margin:0 auto;"
                                        v-model="id_reward_temp">
                                    <option value="" selected>{{ $t("seleziona_premio") }}</option>
                                    <option v-for="reward in this.rewards_available" :value="reward.id">
                                        <inc-reward-name :reward="reward" :type="reward.tipo"/>
                                    </option>
                                </select>
                            </div>
                            <button class="btn btn-primary btn-sm" style="margin-left:5px;"
                                    type="button" @click="applyReward()">
                                {{ $t("usa_premio") }}
                            </button>
                        </div>

                        <!-- premio selezionato -->
                        <div class="container">
                            <div class="row consegna" v-for="(reward, i) in this.rewards">
                                <div class="col-sm-9 col-md-10">
                                    <span style="padding-left: 55px;">
                                        {{ $t("premio_applicato") }}:
                                        <inc-reward-name :reward="reward.reward" :type="reward.reward.tipo"/>
                                    </span>
                                    <span class="red" style="cursor: pointer;" @click="rewards.splice(i, 1)">
                                        ({{ $t("rimuovi_premio") }} <i class="fa fa-times ml-2"></i>)
                                    </span>
                                </div>
                                <div class="col-sm-3 col-md-2">
                                    <div class="prezzo">{{ (reward.total).toFixedGood(2) }} {{ locale_currency }}</div>
                                </div>
                            </div>

                        </div>
                        <!-- fine premio selezionato -->

                        <!-- fine fidelity -->
                    </div>

                    <div class="subtotale gray">
                        <div class="tot">{{ $t('totale') }}
                            {{ this.total_price.toFixedGood(2) }} {{ this.locale_currency }}
                        </div>
                    </div>

                    <!-- EXTRA -->
                    <extras v-if="this.extras_config.length" :extras="this.extras_config"
                            @onExtrasChange="onExtrasChange"/>

                    <!-- NOTE -->
                    <div class="blocchetto-titolo">
                        <span><img src="/img/be/ico-note.png">
                            {{ $t('carrello_note_generali') }}
                        </span>
                        <br><br>
                        <div class="form-group">
                            <textarea class="form-control" rows="3" v-model="note_cliente"
                                      :placeholder="$t('note')"></textarea>
                        </div>
                    </div>

                    <div class="totale bg-black">
                        <button class="btn btn-default float-left" type="button" @click="reset()">
                            {{ $t('carrello_ord_del') }}
                        </button>
                        <div id="paypal-button-container" class="w-auto d-inline-block float-right"
                             v-if="this.payment_mode && this.payment_mode.tipo === 'PAYPAL'"></div>
                        <button class="btn btn-primary float-right" type="button" v-else @click="submit()"
                                :disabled="this.loading_visible">
                            {{ $t('carrello_ord_conf') }}
                        </button>
                        <div class="clearfix"></div>
                    </div>
                </div>
            </div>
        </div>

        <inc-payment-overlay v-if="this.paying"/>

        <modal-billing-address :billing-address="this.billing_address"
                               :countries="this.countries"
                               v-if="this.show_modal_billing_address"
                               @close="hideModalBillingAddress"/>
        <modal-rewards :rewards="this.fidelity_rewards" v-if="this.show_modal_rewards"
                       @close="show_modal_rewards = false"/>
        <modal-stripe-payment v-if="this.show_stripe_payment_modal"
                              :stripe="this.stripe"
                              :save="this.stripe_payment_modal_save"
                              :hide-save-card="!this.user_authenticated"
                              @close="show_stripe_payment_modal = false"
                              @onSubmit="onSubmitCreditCard"
        />
    </form>
</template>

<script>
import moment from 'moment';
import {mapActions, mapGetters, mapState} from 'vuex';
import braintree from 'braintree-web';

import {getMixedInfo, getPrivacyCheckboxes} from '../../api/restaurant';
import {
    getBillingAddress,
    getCoupons,
    getDeliveryAddresses,
    getFidelityCardRewards,
    order,
    paypalExecuteTransaction,
    paypalGetClientToken,
    stripeGetClientSecret,
    stripeGetPaymentMethods,
    stripeNotifyConfirmation
} from '../../api/account';
import {getRewardName} from '../../libraries/utils';
import {getCountries} from "../../api/mixed";
import {getPOSInfo} from "../../api/restaurant/dil";

import ModalErrors from '../partials/ModalErrors';
import ModalBillingAddress from './partials/ModalBillingAddress';
import IncCartProducts from './partials/IncCartProducts';
import ModalRewards from './partials/ModalRewards';
import IncRewardName from '../fidelity/partials/IncRewardName';
import ModalStripePayment from '../partials/ModalStripePayment';
import IncDeliveryAddresses from "./partials/IncDeliveryAddresses";
import IncPaymentMode from "./partials/IncPaymentMode";
import IncPaymentOverlay from "../partials/IncPaymentOverlay";
import IncUserData from "./partials/IncUserData";
import Extras from "./partials/Extras";

export default {
    name: "Summary",
    components: {
        Extras,
        IncUserData,
        IncPaymentOverlay,
        IncPaymentMode,
        IncDeliveryAddresses,
        ModalStripePayment,
        IncRewardName,
        ModalRewards,
        IncCartProducts,
        ModalBillingAddress,
        ModalErrors,
    },
    data() {
        return {
            configuration_service: null,
            delivery_cities: [],
            fidelity_card_promotion: null,
            fidelity_rewards: [],
            selected_address: undefined,
            addresses: [],
            billing_address: null,
            invoice_enabled: false,
            note_cliente: '',
            coupon_temp: '',
            coupon: null,
            rewards: [],
            id_reward_temp: '',
            delivery_point: '',
            current_pos_info: null,

            show_modal_billing_address: false,
            show_modal_rewards: false,
            coupon_check: false,
            show_stripe_payment_modal: false,
            stripe_payment_modal_save: false,
            order_object: null,

            countries: [],

            payment_modes: [],
            payment_mode: null,
            stripe: null,
            paying: false,
            privacy_checkboxes: [],
            user_data: null,

            extras_config: [],
            extras: null
        }
    },
    created() {
        if ((this.order.type === 'ORDINA_TAVOLO' && this.$route.query.guest) || this.user_authenticated) {
            this.fetch();
        } else {
            this.$router.replace({name: 'cart'});
        }
    },
    watch: {
        // call again the method if the route changes
        $route(to, from) {
            // react to route changes...
            if (to.name === 'cart.summary') {
                Object.assign(this.$data, this.$options.data.call(this));
                this.fetch();
            }
        },
        selected_address(address) {
            if (address) {
                global.selectedAddressId = address.id;
            } else {
                global.selectedAddressId = null;
            }
        },
        /*language() {
            if (this.payment_mode && this.payment_mode.tipo === 'PAYPAL') {
                this.initializePaypal();
            }
        }*/
    },
    computed: {
        total_fixed_cost: function () {
            if (this.configuration_service && this.configuration_service.costo_fisso) {
                if (!this.configuration_service.costo_fisso_soglia_gratis || (
                    this.order_total_products_price < this.configuration_service.costo_fisso_soglia_gratis
                )) {
                    let total_fixed_cost = this.configuration_service.costo_fisso;

                    if (this.configuration_service.costo_fisso_tipo === 'PERCENTUALE') {
                        total_fixed_cost = (this.order_total_products_price / 100 * total_fixed_cost);
                    }

                    if (this.order.n_persone) {
                        return total_fixed_cost * this.order.n_persone;
                    }

                    return total_fixed_cost;
                } else {
                    return false;
                }
            }

            return false;
        },
        total_coupon: function () {
            if (this.coupon && this.coupon.valore) {
                if (this.coupon.tipo === 'VALORE') {
                    if (this.coupon.valore > this.order_total_products_price_for_coupon) {
                        return this.order_total_products_price_for_coupon;
                    }

                    return this.coupon.valore;
                } else {
                    return (this.order_total_products_price_for_coupon / 100 * this.coupon.valore).fixTo(2);
                }
            }

            return 0;
        },
        total_rewards: function () {
            return this.rewards.reduce((accumulator, reward) => {
                return accumulator + reward.total;
            }, 0);
        },
        total_price: function () {
            let total_price = this.order_total_products_price;

            if (this.total_coupon) {
                total_price += (-1 * this.total_coupon);
            } else if (this.total_rewards) {
                total_price += this.total_rewards;
            }

            if (total_price < 0) {
                total_price = 0;
            }

            if (this.total_fixed_cost) {
                total_price += this.total_fixed_cost;
            }

            if (this.delivery_charge) {
                total_price += this.delivery_charge;
            }

            return total_price;
        },
        add_delivery_charge: function () {
            if (['DELIVERY', 'DIL'].includes(this.order.type)) {
                let add = !(this.coupon && this.coupon.f_spedizione_gratis);

                if (this.order.type === 'DELIVERY') {
                    add &= !!this.selected_address;
                } else if (this.order.type === 'DIL') {
                    add &= !!this.current_pos_info;
                }

                return add;
            }

            return false;
        },
        delivery_charge: function () {
            let speseConsegna = null;

            if (this.add_delivery_charge) {
                if (this.configuration_service.soglia_gratis && this.order_total_products_price < this.configuration_service.soglia_gratis) {
                    if (this.order.type === 'DELIVERY') {
                        speseConsegna = this.selected_address.spese_consegna;
                    } else {
                        speseConsegna = this.current_pos_info.spese_consegna;
                    }
                }
            }

            return speseConsegna;
        },
        fidelity_points: function () {
            let points = null;
            if (this.fidelity_card_promotion && (this.fidelity_card_promotion.mask_locali & this.locale.id)) {
                points = 0;
                switch (this.fidelity_card_promotion.tipo_punteggio) {
                    case 'IMPORTO_SPESO':
                        points = Math.floor(this.order_total_products_price / this.fidelity_card_promotion.valore_punteggio);
                        break;
                    case 'NUMERO_PRODOTTI':
                        let probable_scores = {};

                        this.order.items.forEach((item) => {
                            let found_typology = false;
                            let found_product = false;

                            let last_score = null;

                            this.fidelity_card_promotion.punteggi.forEach((punteggio) => {
                                if (punteggio.id_tipologia_prodotto === item.item.id_tipologia_prodotto && punteggio.id_prodotto === -1) {
                                    found_typology = true;

                                    if (last_score === null) {
                                        last_score = punteggio;
                                    }
                                }

                                if (punteggio.id_prodotto === item.item.id) {
                                    found_product = true;
                                    last_score = punteggio;
                                }
                            });

                            if (found_product || found_typology) {
                                let key = found_product ? 'prodotto_' + item.item.id : 'tipologia_' + item.item.id_tipologia_prodotto;
                                let quantita = item.quantity;
                                if (probable_scores.hasOwnProperty(key)) {
                                    quantita += probable_scores[key];

                                    delete probable_scores[key];
                                }

                                let obtained_points = Math.floor(quantita / last_score.valore);
                                probable_scores[key] = (quantita % last_score.valore);

                                points += obtained_points;
                            }
                        });
                        break;
                }
            }

            return points;
        },
        rewards_available: function () {
            return this.fidelity_rewards.filter((fidelity_reward) => {
                return (this.rewards.findIndex((item_reward) => {
                    return fidelity_reward.id === item_reward.reward.id;
                }) === -1);
            });
        },
        can_add_rewards: function () {
            return this.rewards_available.length && (
                this.rewards.length ? this.rewards[0].reward.f_cumulabile : true
            );
        },
        items_with_nodiscount_present: function () {
            return !!this.order.items.find((item) => {
                return !item.item.f_sconto;
            });
        },
        zone: function () {
            if (this.order.type === 'DIL') {
                return this.service_points.find((zone) => {
                    return zone.id === this.order.id_punto_di_servizio;
                });
            }

            return null;
        },
        order_address: function () {
            if (this.configuration_service) {
                if (this.order.address && this.order.address.tipo === this.configuration_service.tipo_modalita_zone) {
                    return this.order.address;
                }
            }

            return null;
        },
        ...mapState('global', {
            loading_visible: state => state.loading_visible
        }),
        ...mapState('restaurant', {
            id_ristorante: state => state.id,
            locale: state => state.locale,
            restaurant_settings: state => state.impostazioni,
            service_points: state => state.punti_di_servizio
        }),
        ...mapState('order', {
            order: state => state
        }),
        ...mapState('localization', {
            language: state => state.language
        }),
        ...mapState('auth', {
            user: state => state
        }),
        ...mapGetters('auth', {
            user_authenticated: 'authenticated'
        }),
        ...mapGetters('order', {
            order_total_products_price: 'totalProductsPrice',
            order_total_products_price_for_coupon: 'totalProductsPriceForCoupon'
        }),
        ...mapGetters('restaurant', {
            locale_currency: 'localeCurrency'
        })
    },
    methods: {
        fetch: function () {
            this.showLoading(true);
            getMixedInfo(this.language, {
                id_ristorante: this.id_ristorante,
                id_locale: this.locale.id,
                modalita_pagamento: true,
                mezzi_pagamento: true,
                credenziali_pagamento: true,
                fidelity_card_promozione: true,
                configurazione_takeaway: this.order.type === 'TAKEAWAY',
                configurazione_delivery: this.order.type === 'DELIVERY',
                configurazione_dil: this.order.type === 'DIL',
                configurazione_ordina_tavolo: this.order.type === 'ORDINA_TAVOLO',
                consegne_citta: this.order.type === 'DELIVERY',
                configurazione_mangia_ristorante: this.order.type === 'MANGIA_RISTORANTE',
                tipo_ordine: this.order.type,
                configurazioni_extra: true,
            }).then((response) => {
                //Configurazione
                if (this.order.type === 'TAKEAWAY') {
                    this.configuration_service = response.configurazione_takeaway;
                } else if (this.order.type === 'DELIVERY') {
                    this.configuration_service = response.configurazione_delivery;
                    this.delivery_cities = response.consegne_citta.filter((city) => {
                            const cond1 = city.tipo === this.configuration_service.tipo_modalita_zone;
                            const cond2 = this.order.address ?
                                this.order.address.id_consegna_citta === city.id : true;
                            return cond1 && cond2;
                        },
                    );

                    if (this.order.address && this.order.address.id_consegna_zona) {
                        this.delivery_cities.forEach((city) => {
                            city.zone = city.zone.filter((zone) => {
                                return zone.id === this.order.address.id_consegna_zona;
                            });
                        });
                    }

                } else if (this.order.type === 'MANGIA_RISTORANTE') {
                    this.configuration_service = response.configurazione_mangia_ristorante;
                } else if (this.order.type === 'DIL') {
                    this.configuration_service = response.configurazione_dil;
                } else if (this.order.type === 'ORDINA_TAVOLO') {
                    this.configuration_service = response.configurazione_ordina_tavolo;
                }

                this.extras_config = response.configurazioni_extra;
                this.fidelity_card_promotion = response.fidelity_card_promozione;

                //Se è di tipo COORDINATE, idIndirizzoSelezionato non è supportato come inizio
                if (this.order_address && this.order_address.tipo === 'COORDINATE') {
                    global.selectedAddressId = this.order.address.id ? this.order.address.id : null;
                }

                this.fetchMoreInfo(response.modalita_pagamento, response.mezzi_pagamento);

            }).catch((messages) => {
                alert(messages.join('\n'));
                this.showLoading(false);
            });
        },
        fetchMoreInfo: function (paymentModes, paymentMehods) {
            const promises = [
                this.retrievePaymentMethods(paymentModes, paymentMehods),
                getCountries(this.language, {}).then((response) => {
                    this.countries = response.countries;
                })
            ];

            if (this.user_authenticated) {
                promises.push(this.retrieveBillingAddress(), this.retrieveFidelityRewards());
            } else {
                promises.push(this.retrievePrivacyCheckboxes());
            }

            if (this.order.type === 'DELIVERY') {
                promises.push(this.retrieveDeliveryAddresses());
            }

            //estraggo le info per i punti di servizio
            if (this.order.type === 'DIL') {
                promises.push(this.retrievePOSInfo());
            }

            axios.all(promises).then(() => {
                this.invoice_enabled = !!this.locale.f_fat_obbligatoria;

                this.showLoading(false);
            }).catch(({messages}) => {
                alert(messages.join('\n'));
            });
        },
        retrieveDeliveryAddresses: function () {
            getDeliveryAddresses(this.language, {
                id_ristorante: this.id_ristorante,
                id_locale: this.locale.id,
                email: this.user.email,
                api_key: this.user.api_key,
                tipo_modalita_zone: this.configuration_service.tipo_modalita_zone,
                id_consegna_citta: this.order_address ? this.order_address.id_consegna_citta : null
            }).then((response) => {
                //Primo filtro per eliminare indirizzi che non sono compatibili con il tipo di consegna attuale
                let filteredAddresses = response.indirizzi;

                if (filteredAddresses.length) {
                    let predefined = null;

                    if (!this.order_address || this.order_address.tipo === 'MANUALE') {
                        filteredAddresses = filteredAddresses.filter((address) => {
                            if (this.order_address) {
                                let cond1 = address.id_consegna_citta === this.order_address.id_consegna_citta;
                                let cond2 = this.order_address.id_consegna_zona
                                    ? address.id_consegna_zona === this.order_address.id_consegna_zona : true;
                                return cond1 && cond2;
                            }

                            return true;
                        });

                        predefined = filteredAddresses.find((item) => {
                            return !!item.predefinito;
                        });

                        if (!this.order_address) {
                            //Se non c'è l'indirizzo scelto in partenza eseguo la solita routine
                            if (global.selectedAddressId) {
                                const addressAlreadySelected = filteredAddresses.find((address) => {
                                    return address.id === global.selectedAddressId;
                                });

                                if (addressAlreadySelected) {
                                    predefined = addressAlreadySelected;
                                }
                            }
                        }

                        if (!predefined) {
                            predefined = filteredAddresses[0];
                        }

                        this.selected_address = predefined;
                    } else {
                        //Popolamento automatico per tipo COORDINATE non disponibile all'inizio
                        if (global.selectedAddressId) {
                            const addressAlreadySelected = filteredAddresses.find((address) => {
                                return address.id === global.selectedAddressId;
                            });

                            if (addressAlreadySelected) {
                                this.selected_address = addressAlreadySelected;
                            }
                        }
                    }
                }

                this.addresses = filteredAddresses;
                if (this.selected_address) {
                    this.checkAddressValidity(this.selected_address);
                }
            }).catch(({messages}) => {
                alert(messages.join('\n'));
            });
        },
        retrieveBillingAddress: function () {
            getBillingAddress(this.language, {
                id_ristorante: this.id_ristorante,
                email: this.user.email,
                api_key: this.user.api_key
            }).then((response) => {
                this.billing_address = response.indirizzo;
            }).catch(({messages}) => {
                alert(messages.join('\n'));
            })
        },
        retrieveFidelityRewards: function () {
            getFidelityCardRewards(this.language, {
                id_ristorante: this.id_ristorante,
                id_locale: this.locale.id,
                email: this.user.email,
                api_key: this.user.api_key
            }).then((response) => {
                this.fidelity_rewards = response.premi;
            }).catch(({messages}) => {
                alert(messages.join('\n'));
            });
        },
        retrievePaymentMethods: function (paymentModes, paymentMehods) {
            if (this.user_authenticated && paymentModes.find((obj) => {
                return obj.tipo === "STRIPE_CARTACREDITO";
            })) {
                stripeGetPaymentMethods(this.language, {
                    id_ristorante: this.id_ristorante,
                    id_locale: this.locale.id,
                    api_key: this.user.api_key,
                }).then((response) => {
                    this.handlePaymentMethods(paymentModes, paymentMehods, response.methods);
                });
            } else {
                this.handlePaymentMethods(paymentModes, paymentMehods, []);
            }
        },
        retrievePOSInfo: function () {
            getPOSInfo(this.language, {
                    id_ristorante: this.id_ristorante,
                    id_locale: this.locale.id,
                    id_punto_di_servizio: this.order.id_punto_di_servizio,
                },
            ).then((response) => {
                this.current_pos_info = response.info;
            }).catch(({messages}) => {
                alert(messages.join('\n'));
            });
        },
        retrievePrivacyCheckboxes: function () {
            getPrivacyCheckboxes(this.language, {
                id_ristorante: this.id_ristorante,
                id_locale: this.locale.id,
                for_reservation: true,
            }).then((response) => {
                this.privacy_checkboxes = response.checkboxes;
            }).catch(({messages}) => {
                alert(messages.join('\n'));
            })
        },
        handlePaymentMethods: function (paymentModes, paymentMehods, stripeCards) {
            let idModalitaPagamento = 1;

            //Modalita pagamento
            const modalitaPagamento = [];
            paymentModes.forEach((obj) => {
                switch (obj.tipo) {
                    case 'CONTANTI':
                        paymentMehods.forEach((mezzo) => {
                            modalitaPagamento.push({
                                id: idModalitaPagamento++,
                                tipo: obj.tipo,
                                label: mezzo.label,
                                tipo_mezzo: mezzo.value,
                            });
                        });
                        break;
                    case 'STRIPE_CARTACREDITO':
                        this.stripe = Stripe(obj.credenziali.publishable_key, {locale: this.language});

                        if (stripeCards.length) {
                            stripeCards.forEach((spm) => {
                                modalitaPagamento.push({
                                    id: idModalitaPagamento++,
                                    tipo: obj.tipo,
                                    label: null,
                                    info: spm,
                                    credenziali: obj.credenziali,
                                });
                            });
                        } else {
                            modalitaPagamento.push({
                                id: idModalitaPagamento++,
                                tipo: obj.tipo,
                                label: this.$t('carrello_pag_carte'),
                                info: null,
                                credenziali: obj.credenziali,
                            });
                        }
                        break;
                    case 'PAYPAL':
                        modalitaPagamento.push({
                            id: idModalitaPagamento++,
                            tipo: obj.tipo,
                            label: 'PayPal',
                            info: null
                        });
                        break;
                }
            });

            this.payment_modes = modalitaPagamento;
        },
        onChangeAddress: function (address) {
            this.checkAddressValidity(address);
            this.selected_address = address;
        },
        onClickYesAddress: function (address) {
            this.selected_address = address;
            this.retrieveDeliveryAddresses();
        },
        checkAddressValidity: function (address) {
            if (this.order.type === 'DELIVERY') {
                if (!address.consegna_citta) {
                    this.showModalErrors({
                        title: this.$t('attenzione_label').toUpperCase(),
                        errors: [
                            this.$t('indirizzo_non_valido')
                        ]
                    });

                    return false;
                } else {
                    let min_charge = null;
                    if (address.consegna_zona && address.consegna_zona.spesa_minima) {
                        min_charge = address.consegna_zona.spesa_minima;
                    } else if (address.consegna_citta) {
                        min_charge = address.consegna_citta.spesa_minima;
                    }

                    if (min_charge) {
                        if (this.order_total_products_price < min_charge) {
                            this.showModalErrors({
                                title: this.$t('attenzione_label').toUpperCase(),
                                errors: [
                                    this.$t('spesa_min_indirizzo') + ' ' + min_charge.toFixedGood(2) + this.locale_currency
                                ]
                            });

                            return false;
                        }
                    }
                }
            }

            return true;
        },
        applyCoupon: function () {
            if (this.rewards.length) {
                this.showModalErrors({
                    title: this.$t('attenzione_label').toUpperCase(),
                    errors: [this.$t('sconto_problema_#1')]
                });
            } else {
                this.coupon_check = true;
                getCoupons(this.language, {
                    id_ristorante: this.id_ristorante,
                    id_locale: this.locale.id,
                    email: this.user.email,
                    api_key: this.user.api_key
                }).then((response) => {
                    const coupon = response.codici_sconto.find((obj) => {
                        return obj.nome === this.coupon_temp.trim().toUpperCase();
                    });

                    if (coupon) {
                        if (!coupon.tipi_orario.includes(this.order.type.toUpperCase())) {
                            this.showModalErrors({
                                title: this.$t('attenzione_label').toUpperCase(),
                                errors: [this.$t('coupon_non_utilizzabile')]
                            });
                        } else if ((coupon.dal && coupon.al) &&
                            !moment(this.order.date).isBetween(
                                moment(coupon.dal, "YYYY-MM-DD HH:mm:ss"),
                                moment(coupon.al, "YYYY-MM-DD HH:mm:ss")
                            )) {

                            this.showModalErrors({
                                title: this.$t('attenzione_label').toUpperCase(),
                                errors: [this.$t('')]
                            });
                        } else if (this.order_total_products_price_for_coupon < coupon.ordine_minimo) {
                            this.showModalErrors({
                                title: this.$t('attenzione_label').toUpperCase(),
                                errors: [
                                    this.$t('sconto_problema_#4') + ' ' + coupon.ordine_minimo + ' ' + this.locale_currency
                                ]
                            });
                        } else {
                            this.coupon = coupon;
                        }
                    } else {
                        this.showModalErrors({
                            title: this.$t('attenzione_label').toUpperCase(),
                            errors: [this.$t('sconto_problema_#2')]
                        });
                    }
                }).catch(({messages}) => {
                    this.showModalErrors({
                        title: this.$t('attenzione_label').toUpperCase(),
                        errors: messages
                    });
                }).finally(() => {
                    this.coupon_check = false;
                });
            }
        },
        applyReward: function () {
            //ATTENZIONE copiato spudoratamente dall'app, sta cosa è un degheio
            if (this.coupon) {
                this.showModalErrors({
                    title: this.$t('attenzione_label').toUpperCase(),
                    errors: [this.$t('premio_problema_#1')]
                });
            } else {
                let reward_temp = null;
                if (this.id_reward_temp) {
                    reward_temp = this.rewards_available.find((reward) => {
                        return reward.id === this.id_reward_temp;
                    });
                }

                if (reward_temp) {
                    //Controllo se è cumulabile o non cumulabile, controllando anche la cumulabilità dei prodotti presenti
                    let not_cumulabile_ok = (!reward_temp.f_cumulabile && !this.rewards.length);
                    let cumulabile_ok = (reward_temp.f_cumulabile && (
                        this.rewards.findIndex((item_reward) => {
                            return item_reward.reward.f_cumulabile && item_reward.reward.id_fidelity_card_promozione === reward_temp.id_fidelity_card_promozione;
                        }) !== -1
                    ));

                    if (not_cumulabile_ok || cumulabile_ok || !this.rewards.length) {
                        this.id_reward_temp = null;
                        let reward = {
                            reward: reward_temp,
                            total: 0
                        };

                        if (reward.reward.tipo === 'PRODOTTO') {
                            let totalInserted = 0;
                            for (let i = 0; i < this.order.items.length; i++) {
                                let product_mobile_id = this.order.items[i].mobile_id;
                                let product_item = this.order.items[i].item;
                                let product_quantity = this.order.items[i].quantity;

                                //Controllo se questo prodotto è compatibile
                                if (product_item.id_tipologia_prodotto === reward.reward.id_tipologia_prodotto
                                    && (reward.reward.id_prodotto === -1 || reward.reward.id_prodotto === product_item.id)) {
                                    //Se è compatibile, controllo se ce n'è ancora uno disponibile
                                    const times_used = this.rewards.filter((item_reward) => {
                                        return product_mobile_id === (item_reward.mobile_id_product ? item_reward.mobile_id_product : -1);
                                    }).length;

                                    if (times_used < product_quantity) {
                                        reward.mobile_id_product = product_mobile_id;
                                        reward.total = -1 * product_item.standard_proportion.prezzo;

                                        reward.id_prodotto = product_item.id;
                                        reward.nome_prodotto = product_item.nome;

                                        let id_tipologia_prodotto = null;
                                        let nome_tipologia_prodotto = '';
                                        if (reward.reward.tipologia) {
                                            id_tipologia_prodotto = reward.reward.tipologia.id;

                                            if (reward.reward.tipologia.traduzioni.length)
                                                nome_tipologia_prodotto = reward.reward.tipologia.traduzioni[0].nome;
                                        }
                                        reward.nome_tipologia_prodotto = nome_tipologia_prodotto;
                                        reward.id_tipologia_prodotto = id_tipologia_prodotto;
                                        totalInserted++;

                                        this.rewards.push(reward);
                                        reward_temp = null;
                                        break;
                                    }
                                }
                            }

                            if (!totalInserted) {
                                this.showModalErrors({
                                    title: this.$t('attenzione_label').toUpperCase(),
                                    errors: [this.$t('cannot_select_reward_1') + ' "' + getRewardName(reward.reward, reward.reward.tipo) + '" ' + this.$t('cannot_select_reward_2')]
                                });
                            }
                        } else {

                            if (reward.reward.tipo === 'PERCENTUALE') {
                                reward.total = -1 * (this.order_total_products_price / 100 * reward.reward.valore);
                            } else {
                                reward.total = -1 * reward.reward.valore;
                            }

                            this.rewards.push(reward);
                            reward_temp = null;
                        }
                    } else {
                        this.showModalErrors({
                            title: this.$t('attenzione_label').toUpperCase(),
                            errors: [this.$t('fidelity_card_promozione_non_cumulabile')]
                        });
                    }
                }
            }
        },
        hideModalBillingAddress: function (billing_address) {
            if (billing_address) {
                this.billing_address = billing_address
            }

            this.show_modal_billing_address = false
        },
        reset: function () {
            this.resetOrder();
            this.$router.push({name: 'orders'});
        },
        submit: async function () {
            if (!this.payment_mode) {
                this.showModalErrors({
                    title: this.$t('attenzione_label').toUpperCase(),
                    errors: [
                        this.$t('nessun_metodo_selezionato')
                    ]
                });
            } else {
                if (this.invoice_enabled && this.billing_address === null) {
                    this.showModalErrors({
                        title: this.$t('attenzione_label').toUpperCase(),
                        errors: [
                            this.$t('carrello.messaggio_alert_fattura')
                        ]
                    });
                } else {
                    if (this.order.type === 'DIL') {
                        if (!this.delivery_point) {
                            this.showModalErrors({
                                title: this.$t('attenzione_label').toUpperCase(),
                                errors: [
                                    this.$t('messaggio_alert_punto_consegna')
                                ]
                            });
                        } else {
                            return await this.doOrder();
                        }
                    } else if (this.order.type === 'DELIVERY') {
                        if (!this.selected_address) {
                            this.showModalErrors({
                                title: this.$t('attenzione_label').toUpperCase(),
                                errors: [
                                    this.$t('carrello.messaggio_alert_indirizzo')
                                ]
                            });
                        } else if (this.checkAddressValidity(this.selected_address)) {
                            return await this.doOrder();
                        }
                    } else if (!this.user_authenticated) {
                        if (!this.user_data || !this.user_data.name || !this.user_data.surname || !this.user_data.phone || !this.user_data.privacy) {
                            this.showModalErrors({
                                title: this.$t('attenzione_label').toUpperCase(),
                                errors: [
                                    "Compila tutti i dati cliente per continuare"
                                ]
                            });
                        } else {
                            return await this.doOrder();
                        }
                    } else {
                        return await this.doOrder();
                    }
                }
            }

            return false;
        },
        doOrder: async function () {
            if (
                this.extras_config.length &&
                (!this.extras || !!this.extras.find(extra => extra.value === null))
            ) {
                this.showModalErrors({
                    title: this.$t('attenzione_label').toUpperCase(),
                    errors: [
                        "Per continuare è necessario specificare tutti gli extra"
                    ]
                });
                return false;
            }


            this.showLoading(true);

            this.order_object = {
                id_ristorante: this.id_ristorante,
                email: this.user.email,
                api_key: this.user.api_key,
                id_locale: this.locale.id,
                modalita_pagamento: this.payment_mode.tipo,
                preferenza_pagamento: this.payment_mode.tipo === 'CONTANTI' ? this.payment_mode.tipo_mezzo : null,
                tipo_ordine: this.order.type.toUpperCase(),
                note_cliente: this.note_cliente,
                dispositivo: 'SITO',
                f_fattura: this.invoice_enabled,
                prodotti: this.order.items,
                data_ora_consegna_ritiro: this.order.type === 'ORDINA_TAVOLO' ?
                    moment().format("YYYY-MM-DD HH:mm:ss") : this.order.date,
                data_ora_ordine: moment().format("YYYY-MM-DD HH:mm:ss"),
                totale_ordine: this.total_price,
                id_codice_sconto: (this.coupon ? this.coupon.id : null),
                rewards: this.rewards,
                id_orario: this.order.id_orario,
                f_appena_possibile: this.order.f_appena_possibile,
                n_persone: this.order.n_persone,
                punto_di_servizio_label_tipologia: this.order.label_tipologia,
                extra: this.extras
            };

            if (!this.user_authenticated) {
                this.order_object.ospite = 1
                this.order_object.cliente = {};
                this.order_object.cliente.f_privacy = this.user_data.privacy.privacy ? 1 : 0;
                this.order_object.cliente.nome = this.user_data.name;
                this.order_object.cliente.cognome = this.user_data.surname;
                this.order_object.cliente.telefono = this.user_data.phone;
            } else {
                this.order_object.ospite = 0;
            }

            if (this.order.type === 'ORDINA_TAVOLO') {
                this.order_object.id_tavolo = this.order.table.id;
                this.order_object.nome_tavolo = this.order.table.nome;
            }

            if (['DELIVERY', 'DIL'].includes(this.order.type)) {
                this.order_object.consegna_ritiro_fine_fascia = this.order.fine_fascia;
                this.order_object.spese_consegna = this.delivery_charge;

                if (this.order.type === 'DIL') {
                    this.order_object.id_punto_di_servizio = this.zone.id;
                    this.order_object.punto_di_servizio_nome = this.zone.traduzione.nome;
                    this.order_object.punto_di_servizio_punto_consegna = this.delivery_point;
                    this.order_object.punto_di_servizio_label_delivery = this.zone.traduzione.label_indirizzo_delivery;
                } else {
                    this.order_object.indirizzo = this.selected_address.indirizzo;
                    this.order_object.numero_civico = this.selected_address.numero;
                    this.order_object.cap_citta = this.selected_address.cap_citta;
                    this.order_object.cap_zona = this.selected_address.cap_zona;
                    this.order_object.localita_citta = this.selected_address.localita_citta;
                    this.order_object.localita_zona = this.selected_address.localita_zona;
                    this.order_object.campanello = this.selected_address.campanello;
                    this.order_object.indirizzo_note = this.selected_address.note;
                    this.order_object.id_indirizzo = this.selected_address.id;
                    this.order_object.provincia = this.selected_address.provincia;
                    this.order_object.stato = this.selected_address.nazione;
                }
            }

            if (this.invoice_enabled) {
                this.order_object.fat_fatturazione_tipo = this.billing_address.fatturazione_tipo;
                this.order_object.fat_ragione_sociale = this.billing_address.ragione_sociale;
                this.order_object.fat_cod_fisc = this.billing_address.cod_fisc;
                this.order_object.fat_piva = this.billing_address.p_iva;
                this.order_object.fat_indirizzo = this.billing_address.indirizzo;
                this.order_object.fat_numero_civico = this.billing_address.numero;
                this.order_object.fat_cap = this.billing_address.cap_citta;
                this.order_object.fat_provincia = this.billing_address.provincia;
                this.order_object.fat_stato = this.billing_address.nazione;
                this.order_object.fat_localita = this.billing_address.localita_citta;
                this.order_object.fat_sdi = this.billing_address.sdi;
                this.order_object.fat_pec = this.billing_address.pec;
            }

            if (this.total_fixed_cost !== false) {
                this.order_object.costo_fisso_valore = this.configuration_service.costo_fisso;
                this.order_object.costo_fisso_tipo = this.configuration_service.costo_fisso_tipo;
                this.order_object.costo_fisso_nome = this.configuration_service.costo_fisso_nome;
                this.order_object.costo_fisso_descrizione = this.configuration_service.costo_fisso_descrizione;
            }

            try {
                const data = await order(this.language, this.order_object);

                this.order_object.id = data.id;
                this.order_object.totale_ordine = data.totale;
                this.order_object.token = data.token;

                this.showLoading(false);

                if (!this.order_object.totale_ordine) {
                    this.goToFinal();
                    return;
                }

                switch (this.order_object.modalita_pagamento) {
                    case 'STRIPE_CARTACREDITO':
                        if (this.payment_mode.info) {
                            await this.proceedStripePayment(this.payment_mode.info.id, this.payment_mode.saveIt);
                            this.goToFinal();
                        } else {
                            this.show_stripe_payment_modal = true;
                        }
                        break;
                    case 'PAYPAL':
                        //per PAYPAL guardare onPaymenModePress
                        break;
                    default:
                        this.goToFinal();
                        break;
                }

                return true;
            } catch ({messages}) {
                this.showModalErrors({
                    title: this.$t('attenzione_label').toUpperCase(),
                    errors: messages
                });
                this.showLoading(false);

                return false;
            }
        },
        goToFinal: function () {
            this.resetOrder();
            const query = {};
            if (this.order_object.token) {
                query.token = this.order_object.token;
            }

            this.$router.replace({name: 'orders.summary', params: {id: this.order_object.id}, query});
        },
        onPaymenModePress: function (item) {
            this.payment_mode = item;

            if (this.payment_mode.tipo === "PAYPAL") {
                this.initializePaypal();
            }
        },
        onNewCardPress: function () {
            this.stripe_payment_modal_save = true;
            this.show_stripe_payment_modal = true;
        },
        onCardDeletePress: function (item) {
            const index = this.payment_modes.findIndex((mode) => mode.id === item.id);
            this.payment_modes.splice(index, 1);
            this.payment_mode = null;
        },
        proceedStripePayment: function (paymentMethod, savePaymentMethod) {
            return new Promise((resolve, reject) => {
                this.showLoading(true);

                stripeGetClientSecret(this.language, {
                    id_ristorante: this.id_ristorante,
                    api_key: this.user.api_key,
                    entita_tipo: 'ORDINE',
                    entita_id: this.order_object.id
                }).then((data) => {
                    this.stripe.confirmCardPayment(data.client_secret, Object.assign({
                        payment_method: paymentMethod
                    }, savePaymentMethod ? {
                        setup_future_usage: 'on_session'
                    } : {})).then((response) => {
                        if (response.paymentIntent) {
                            //this.showLoading(false);
                            if (response.paymentIntent.status === 'succeeded') {
                                //@deprecated
                                stripeNotifyConfirmation(this.language, {
                                    entita_tipo: 'ORDINE',
                                    entita_id: this.order_object.id,
                                    id_ristorante: this.id_ristorante,
                                    api_key: this.user.api_key
                                }).then(() => {
                                    resolve();
                                }).catch(({messages}) => {
                                    this.showModalErrors({
                                        title: this.$t('attenzione_label').toUpperCase(),
                                        errors: messages
                                    });
                                    reject();
                                }).finally(() => {
                                    this.showLoading(false);
                                });
                            } else {
                                this.showLoading(false);
                                this.showModalErrors({
                                    title: this.$t('attenzione_label').toUpperCase(),
                                    errors: [this.$t('impossible_confirm_payment')]
                                });
                                reject();
                            }
                        } else if (response.error) {
                            this.showLoading(false);
                            this.showModalErrors({
                                title: this.$t('attenzione_label').toUpperCase(),
                                errors: [response.error.message]
                            });
                            reject();
                        }
                    }).catch((e) => {
                        this.showLoading(false);
                        this.showModalErrors({
                            title: this.$t('attenzione_label').toUpperCase(),
                            errors: [e.message]
                        });
                        reject();
                    });
                }).catch(({messages}) => {
                    this.showLoading(false);
                    this.showModalErrors({
                        title: this.$t('attenzione_label').toUpperCase(),
                        errors: messages
                    });
                    reject();
                });
            });
        },
        onSubmitCreditCard: function (card, savePaymentMethod) {

            if (this.stripe_payment_modal_save) {
                this.stripe.createPaymentMethod({
                    type: 'card',
                    card: card
                }).then((result) => {
                    if (result.paymentMethod) {
                        const {card, id} = result.paymentMethod
                        let latestIndexWithCreditCard = null;

                        for (let i = 0; i < this.payment_modes.length; i++) {
                            if (this.payment_modes[i].tipo === 'STRIPE_CARTACREDITO') {
                                latestIndexWithCreditCard = i;
                            }
                        }

                        const spm = {
                            data: {
                                brand: card.brand,
                                expMonth: card.exp_month,
                                expYear: card.exp_year,
                                last4: card.last4,
                            },
                            type: 'card',
                            id: id
                        };

                        const nuovaModalitaPagamento = {
                            id: new Date().getTime(),
                            tipo: 'STRIPE_CARTACREDITO',
                            label: null,
                            credenziali: this.payment_modes[
                                latestIndexWithCreditCard
                                ].credenziali,
                            info: spm,
                            isFresh: true,
                            saveIt: savePaymentMethod,
                        };

                        this.payment_modes.splice(latestIndexWithCreditCard + 1, 0, nuovaModalitaPagamento);
                        this.payment_mode = nuovaModalitaPagamento;

                        this.show_stripe_payment_modal = false;
                        this.stripe_payment_modal_save = false;
                    }
                });
            } else {
                this.proceedStripePayment({card: card}, savePaymentMethod).then(() => {
                    this.goToFinal();
                }).finally(() => {
                    this.show_stripe_payment_modal = false;
                    this.stripe_payment_modal_save = false;
                });
            }
        },
        initializePaypal: function () {
            paypalGetClientToken(this.language, {
                id_ristorante: this.id_ristorante,
                id_locale: this.locale.id,
                api_key: this.user.api_key,
            }).then((response) => {
                braintree.client.create({
                    authorization: response.client_token
                }).then((clientInstance) => {
                    // Create a PayPal Checkout component.
                    return braintree.paypalCheckout.create({
                        client: clientInstance
                    });
                }).then((paypalCheckoutInstance) => {
                    // Load the PayPal JS SDK (see Load the PayPal JS SDK section)
                    return paypalCheckoutInstance.loadPayPalSDK({
                        //vault: true,
                        currency: this.locale.moneta,
                        intent: 'authorize',
                        commit: true,
                    })
                }).then((paypalCheckoutInstance) => {
                    return paypal.Buttons({
                        env: 'sandbox',
                        fundingSource: paypal.FUNDING.PAYPAL,
                        style: {
                            color: 'gold',
                            shape: 'pill',
                            label: 'paypal',
                            height: 35
                        },
                        createOrder: async () => {
                            if (!this.loading_visible) {
                                if (await this.submit()) {
                                    return paypalCheckoutInstance.createPayment({
                                        flow: 'checkout', // Required
                                        amount: this.order_object.totale_ordine, // Required
                                        currency: this.locale.moneta, // Required, must match the currency passed in with loadPayPalSDK
                                        shippingAddressRequired: false,
                                        intent: 'authorize', // Must match the intent passed in with loadPayPalSDK
                                    });
                                }
                            }

                            return false;
                        },
                        onApprove: (data, actions) => {
                            this.paying = true;
                            this.showLoading(true);
                            return paypalCheckoutInstance.tokenizePayment(data).then((payload) => {
                                // Submit `payload.nonce` to your server
                                paypalExecuteTransaction(this.language, {
                                    id_ristorante: this.id_ristorante,
                                    id_locale: this.locale.id,
                                    api_key: this.user.api_key,
                                    entita_tipo: "ORDINE",
                                    entita_id: this.order_object.id,
                                    nonce: payload.nonce
                                }).then(() => {
                                    this.goToFinal();
                                }).catch(({messages}) => {
                                    this.showModalErrors({
                                        title: this.$t('attenzione_label').toUpperCase(),
                                        errors: messages
                                    });
                                }).finally(() => {
                                    this.paying = false;
                                    this.showLoading(false);
                                });

                            });
                        },
                        //onCancel: (data) => {
                        //this.errors = ['PayPal payment cancelled'];
                        //this.show_modal_errors = true;
                        //},
                        //onError: (err) => {
                        //    this.errors = [err];
                        //    this.show_modal_errors = true;
                        //}
                    }).render('#paypal-button-container');
                }).then(function () {
                    // The PayPal button will be rendered in an html element with the ID
                    // `paypal-button`. This function will be called when the PayPal button
                    // is set up and ready to be used
                }).catch((e) => {
                    console.log(e);
                });

            }).catch((e) => {
                console.error(e);
            });
        },
        onUserDataChange: function (data) {
            this.user_data = data;
        },
        onExtrasChange: function (extras) {
            this.extras = extras;
        },
        ...mapActions('global', [
            'showLoading',
            'showModalErrors'
        ]),
        ...mapActions('order', {
            resetOrder: 'reset',
        })
    }
}
</script>
